import { render, staticRenderFns } from "./ScrollableTable.vue?vue&type=template&id=ad5ec350&scoped=true"
import script from "./ScrollableTable.vue?vue&type=script&lang=js"
export * from "./ScrollableTable.vue?vue&type=script&lang=js"
import style0 from "./ScrollableTable.vue?vue&type=style&index=0&id=ad5ec350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5ec350",
  null
  
)

export default component.exports